(() => {
  let cookieLocalizerStarted = false;
  const localizeNativeCookieUi = () => {
    if (document.documentElement.lang !== 'pt-PT') return;
    if (cookieLocalizerStarted) return;
    cookieLocalizerStarted = true;
    // Translate the observed native UI in place; Shopify retains every control and callback.
    const translations = /* DM_COOKIE_TRANSLATIONS_START */ {
        "Accept total": "Aceitar todos",
        "Acceptare": "Aceitar",
        "Aceste module cookie ne ajută să înțelegem cum interacționați cu site-ul. Utilizăm aceste date pentru a identifica zonele care necesită îmbunătățiri.": "Estes cookies ajudam-nos a compreender como interage com o site. Utilizamos estes dados para identificar as áreas que necessitam de melhorias.",
        "Aceste module cookie stochează detalii despre acțiunile dumneavoastră pentru a vă personaliza următoarea vizită pe site.": "Estes cookies guardam informações sobre as suas ações para personalizar a sua próxima visita ao site.",
        "Aceste module cookie sunt necesare pentru ca site-ul să funcționeze corect, inclusiv capabilități precum autentificarea și adăugarea de articole în coș.": "Estes cookies são necessários para que o site funcione corretamente, incluindo funcionalidades como iniciar sessão e adicionar artigos ao carrinho.",
        "Aceste module cookie sunt utilizate de noi și de partenerii noștri, inclusiv Shopify, pentru a optimiza comunicările de marketing și a vă afișa reclame pe alte site-uri.": "Estes cookies são utilizados por nós e pelos nossos parceiros, incluindo a Shopify, para otimizar as comunicações de marketing e apresentar-lhe anúncios noutros sites.",
        "Aflați mai multe despre modulele cookie pe care le utilizăm și alegeți ce module cookie să permiteți.": "Saiba mais sobre os cookies que utilizamos e escolha quais pretende permitir.",
        "Analize": "Análise",
        "Close dialog": "Fechar diálogo",
        "Consimțământ privind modulele cookie": "Consentimento relativo aos cookies",
        "Dvs. vă controlați propriile date": "Tem o controlo dos seus próprios dados",
        "Gestionați preferințele": "Gerir preferências",
        "Marketing": "Marketing",
        "Necesar": "Necessários",
        "Noi și partenerii noștri, inclusiv Shopify, utilizăm module cookie și alte tehnologii pentru a vă personaliza experiența, a vă afișa reclame și a efectua analize și nu vom folosi module cookie sau alte tehnologii în aceste scopuri decât dacă le acceptați. Aflați mai multe în": "Nós e os nossos parceiros, incluindo a Shopify, utilizamos cookies e outras tecnologias para personalizar a sua experiência, apresentar-lhe anúncios e realizar análises. Só utilizaremos cookies ou outras tecnologias para estas finalidades se os aceitar. Saiba mais na",
        "Personalizare": "Personalização",
        "Politica de confidențialitate": "Política de privacidade",
        "Preferințe privind modulele cookie și confidențialitatea": "Preferências de cookies e de privacidade",
        "Refuz total": "Recusar todos",
        "Refuzare": "Recusar",
        "Salvează-mi alegerile": "Guardar as minhas escolhas"
    } /* DM_COOKIE_TRANSLATIONS_END */;
    const nativeSelector = '#shopify-pc__banner, #shopify-pc__prefs__dialog';
    const connected = new WeakSet();
    const translateText = node => {
      const original = node.nodeValue;
      const replacement = translations[original.trim()];
      if (replacement && replacement !== original.trim()) {
        node.nodeValue = original.replace(/\S[\s\S]*\S|\S/, replacement);
      }
    };
    const translateAttributes = element => {
      for (const name of ['aria-label', 'title']) {
        const original = element.getAttribute(name);
        const replacement = original && translations[original.trim()];
        if (replacement && replacement !== original) element.setAttribute(name, replacement);
      }
    };
    const translateTree = element => {
      if (element.nodeType === Node.TEXT_NODE) { translateText(element); return; }
      if (element.nodeType !== Node.ELEMENT_NODE) return;
      translateAttributes(element);
      element.querySelectorAll('[aria-label], [title]').forEach(translateAttributes);
      const textNodes = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      while (textNodes.nextNode()) translateText(textNodes.currentNode);
    };
    const connect = container => {
      if (connected.has(container)) return;
      connected.add(container);
      translateTree(container);
      new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'characterData') translateText(record.target);
          else if (record.type === 'attributes') translateAttributes(record.target);
          else record.addedNodes.forEach(translateTree);
        }
      }).observe(container, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title'] });
    };
    const discover = element => {
      if (element.nodeType !== Node.ELEMENT_NODE) return;
      if (element.matches(nativeSelector)) connect(element);
      element.querySelectorAll(nativeSelector).forEach(connect);
    };
    document.querySelectorAll(nativeSelector).forEach(connect);
    // Native dialogs are appended to body. Inspect only newly appended subtrees.
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(discover)))
      .observe(document.body, { childList: true });
  };
  const boot = (root = document) => {
    const scope = root.querySelector('[data-dm-page]');
    if (!scope || scope.dataset.dmBooted) return;
    scope.dataset.dmBooted = 'true';
    localizeNativeCookieUi();
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    // The offer is visible immediately; only the lower product story reveals on entry.
    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        reveal.unobserve(entry.target);
      }), { threshold: .08, rootMargin: '0px 0px -24px 0px' });
      scope.querySelectorAll('.dm-intro .dm-copy, .dm-collection-heading, .dm-card, .dm-rich__inner, .dm-split__copy, .dm-tech .dm-copy, .dm-section-heading, .dm-connection-grid article, .dm-included, .dm-spec-table, .dm-faq-list').forEach(element => {
        element.classList.add('dm-reveal');
        reveal.observe(element);
      });
      scope.classList.add('dm-motion-ready');
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) {
          reveal.disconnect();
          scope.classList.remove('dm-motion-ready');
        }
      });
    }
    const header = scope.querySelector('.dm-header');
    const toggle = scope.querySelector('[data-dm-menu]');
    const nav = scope.querySelector('.dm-nav');
    toggle?.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
      nav.classList.toggle('is-open', open);
    });
    nav?.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      nav.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.setAttribute('aria-label', window.DM_I18N?.t('Abrir menu') || 'Abrir menu');
      scope.querySelectorAll('.dm-nav details[open]').forEach(item => item.removeAttribute('open'));
    });
    scope.querySelectorAll('.dm-nav details').forEach(details => details.addEventListener('toggle', () => {
      if (!details.open) return;
      scope.querySelectorAll('.dm-nav details').forEach(other => { if (other !== details) other.open = false; });
    }));
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      nav?.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.setAttribute('aria-label', window.DM_I18N?.t('Abrir menu') || 'Abrir menu');
      scope.querySelectorAll('.dm-nav details[open]').forEach(item => item.removeAttribute('open'));
    });
    scope.querySelectorAll('.dm-finish-group').forEach(group => {
      const track = group.querySelector('.dm-card-grid');
      const previous = group.querySelector('[data-dm-slide="previous"]');
      const next = group.querySelector('[data-dm-slide="next"]');
      const counter = group.querySelector('[data-dm-slide-current]');
      const total = group.querySelector('[data-dm-slide-total]');
      const refresh = () => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
        counter.textContent = track.scrollLeft > 2 ? '2' : '1';
        total.textContent = end > 2 ? '2' : '1';
      };
      previous.addEventListener('click', () => track.scrollTo({ left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
      next.addEventListener('click', () => track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
      track.addEventListener('scroll', refresh, { passive: true });
      new ResizeObserver(refresh).observe(track);
      refresh();
    });
    let previousY = window.scrollY;
    let scheduled = false;
    window.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const open = nav?.classList.contains('is-open') || scope.querySelector('.dm-nav details[open]');
        header?.classList.toggle('is-hidden', y > 160 && y > previousY + 3 && !open);
        previousY = y;
        scheduled = false;
      });
    }, { passive: true });
    let variants = [];
    try { variants = window.DM_MARKET?.variants || JSON.parse(scope.querySelector('[data-dm-variants]')?.textContent || '[]'); } catch (_) { return; }
    const select = scope.querySelector('[data-dm-variant-select]');
    const prices = scope.querySelectorAll('[data-dm-price]');
    const image = scope.querySelector('[data-dm-product-image]');
    const buys = [...scope.querySelectorAll('[data-dm-buy]')];
    const buyLabels = buys.map(button => button.textContent);
    const buy = buys[0];
    const addon = scope.querySelector('[data-dm-addon]');
    const colorButtons = scope.querySelectorAll('[data-dm-color]');
    const availability = scope.querySelector('[data-dm-availability]');
    const offer = scope.querySelector('#comprar');
    const ready = buy?.dataset.offerVerified === 'true';
    let currentVariant;
    let checkoutPending = false;
    const galleryButtons = scope.querySelectorAll('[data-dm-gallery]');
    const zoom = scope.querySelector('[data-dm-zoom-dialog]');
    const zoomImage = scope.querySelector('[data-dm-zoom-image]');
    const i18n = window.DM_I18N || { t: (source, values = {}) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll('{' + key + '}', value), source) };
    const activeMarket = () => window.DM_MARKET?.market || { locale: 'pt-PT', currency: 'EUR', language: 'pt-PT', apiLanguage: 'PT_PT' };
    const money = cents => new Intl.NumberFormat(activeMarket().locale, { style: 'currency', currency: activeMarket().currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    let galleryAnimation;
    let priceAnimation;
    let galleryRevision = 0;
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) scope.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
    });
    const animateImage = (element) => {
      if (!element || reducedMotion.matches || !element.animate) return;
      galleryAnimation?.cancel();
      galleryAnimation = element.animate([{ opacity: .35, transform: 'scale(.97)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
    };
    const setGallery = (src, alt, chosen) => {
      scope.querySelector('[data-dm-zoom]')?.classList.toggle('is-product', chosen?.dataset.dmGallery === 'product');
      if (image) {
        const changed = image.src !== new URL(src, location.href).href;
        image.src = src; image.alt = alt;
        if (changed) {
          const revision = ++galleryRevision;
          image.decode().then(() => { if (revision === galleryRevision) animateImage(image); }).catch(() => {});
          const mini = scope.querySelector('[data-dm-mini-image]');
          if (mini && getComputedStyle(mini).display !== 'none' && !reducedMotion.matches && mini.animate) mini.animate([{ opacity: .45, transform: 'scale(.96)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 360, easing: 'ease-out' });
        }
      }
      galleryButtons.forEach(button => button.setAttribute('aria-pressed', String(button === chosen)));
    };
    const applyVariant = (id, updateUrl = true) => {
      if (checkoutPending) return;
      const variant = variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const priceChanged = currentVariant && currentVariant.price !== variant.price;
      currentVariant = variant;
      if (select) select.value = String(variant.id);
      prices.forEach(price => { price.textContent = variant.moneyText; });
      const onSale = window.DM_MARKET?.country !== 'PL' && variant.comparePrice > variant.price;
      const showCompare = window.DM_MARKET?.country === 'PL' ? Number.isFinite(variant.comparePrice) && variant.comparePrice > variant.price : onSale;
      scope.querySelectorAll('[data-dm-compare]').forEach(compare => { compare.textContent = variant.compareText; compare.hidden = !showCompare; });
      scope.querySelectorAll('[data-dm-reference]').forEach(reference => { reference.hidden = !onSale; });
      scope.querySelectorAll('[data-dm-savings]').forEach(saving => { saving.textContent = i18n.t('Poupe {amount}', { amount: money(variant.comparePrice - variant.price) }); saving.hidden = !onSale; });
      scope.querySelectorAll('[data-dm-price-caption]').forEach(caption => { caption.textContent = i18n.t(variant.bundle ? 'Coluna + os dois acessórios' : 'Só a coluna') + ' · ' + activeMarket().currency; });
      const baseVariant = variants.find(v => v.label === variant.label && !v.bundle);
      const kitVariant = variants.find(v => v.label === variant.label && v.bundle);
      if (baseVariant && kitVariant) {
        const extra = kitVariant.price - baseVariant.price;
        const reference = kitVariant.comparePrice - baseVariant.comparePrice;
        scope.querySelectorAll('[data-dm-addon-price]').forEach(price => { price.textContent = `+${money(extra)}`; });
        scope.querySelectorAll('[data-dm-addon-compare]').forEach(compare => { compare.textContent = money(reference); compare.hidden = window.DM_MARKET?.country === 'PL' || reference <= extra; });
      }
      if (priceChanged && !reducedMotion.matches) {
        priceAnimation?.cancel();
        const currentPrice = scope.querySelector('.dm-pricing__current');
        if (currentPrice?.animate) priceAnimation = currentPrice.animate([{ opacity: .5, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'ease-out' });
      }
      if (addon) { addon.checked = Boolean(variant.bundle); addon.disabled = !variants.some(v => v.label === variant.label && v.bundle); }
      scope.querySelector('[data-dm-addon-card]')?.classList.toggle('is-selected', Boolean(variant.bundle));
      scope.querySelectorAll('[data-dm-color-label]').forEach(label => { label.textContent = i18n.t(variant.label); });
      colorButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dmColor === variant.label)));
      if (variant.image) {
        setGallery(variant.image, `Devialet Mania — ${i18n.t(variant.label)}`, [...galleryButtons].find(b => b.dataset.dmGallery === 'product'));
        scope.querySelectorAll('[data-dm-mini-image], [data-dm-gallery-product]').forEach(img => { img.src = variant.image; img.alt = `Devialet Mania — ${i18n.t(variant.label)}`; });
      }
      scope.querySelectorAll('[data-dm-sticky-summary]').forEach(label => { label.textContent = i18n.t(variant.bundle ? 'Com Cocoon + Mania Station' : 'Só a coluna'); });
      scope.querySelectorAll('[data-dm-included-summary]').forEach(label => { label.textContent = variant.bundle ? `Devialet Mania + Cocoon + Mania Station — ${variant.moneyText}` : `${i18n.t('Só a coluna')} — ${variant.moneyText}`; });
      scope.querySelectorAll('[data-dm-select]').forEach(card => {
        const base = variants.find(v => String(v.id) === card.dataset.dmSelect);
        const chosen = base?.label === variant.label;
        card.classList.toggle('is-selected', chosen);
        card.setAttribute('aria-pressed', String(chosen));
        const configured = variants.find(v => v.label === base?.label && Boolean(v.bundle) === Boolean(variant.bundle));
        const cardPrice = card.querySelector('[data-dm-card-price]');
        if (cardPrice && configured) cardPrice.textContent = configured.moneyText;
        const cardCompare = card.querySelector('[data-dm-card-compare]');
        if (cardCompare && configured) { cardCompare.textContent = configured.compareText; cardCompare.hidden = window.DM_MARKET?.country === 'PL' ? !Number.isFinite(configured.comparePrice) || configured.comparePrice <= configured.price : configured.comparePrice <= configured.price; }
      });
      const marketReady = Boolean(window.DM_MARKET?.verified && !window.DM_MARKET.pending && !window.DM_MARKET.switching);
      const enabled = variant.available && ready && marketReady && !String(variant.id).startsWith('preview-');
      buys.forEach(button => { button.setAttribute('aria-disabled', String(!enabled || checkoutPending)); button.href = '#comprar'; });
      if (availability) availability.textContent = variant.available ? '' : i18n.t('Esta configuração está esgotada.');
      if (updateUrl && !String(variant.id).startsWith('preview-')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    };
    select?.addEventListener('change', () => applyVariant(select.value));
    const chooseConfiguration = (color, bundle) => {
      if (checkoutPending) return;
      const variant = variants.find(v => v.label === color && Boolean(v.bundle) === Boolean(bundle));
      if (variant) applyVariant(variant.id);
    };
    colorButtons.forEach(button => button.addEventListener('click', () => chooseConfiguration(button.dataset.dmColor, addon?.checked)));
    addon?.addEventListener('change', () => chooseConfiguration(currentVariant?.label, addon.checked));
    window.addEventListener('popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      if (id) applyVariant(id, false);
    });
    galleryButtons.forEach(button => button.addEventListener('click', () => {
      const productImage = button.dataset.dmGallery === 'product';
      setGallery(productImage ? currentVariant.image : button.dataset.dmGallery, productImage ? `Devialet Mania — ${i18n.t(currentVariant.label)}` : i18n.t(button.dataset.dmGalleryAlt), button);
    }));
    scope.querySelector('[data-dm-zoom]')?.addEventListener('click', () => {
      if (!zoom || !zoomImage || !image) return;
      zoomImage.src = image.src; zoomImage.alt = image.alt; zoom.showModal();
    });
    scope.querySelector('[data-dm-zoom-close]')?.addEventListener('click', () => zoom?.close());
    zoom?.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
    const sticky = scope.querySelector('[data-dm-sticky]');
    if (buy && sticky) {
      const refreshSticky = () => { sticky.hidden = buy.getBoundingClientRect().bottom > 0; };
      let stickyScheduled = false;
      const scheduleSticky = () => {
        if (stickyScheduled) return;
        stickyScheduled = true;
        requestAnimationFrame(() => { refreshSticky(); stickyScheduled = false; });
      };
      new IntersectionObserver(refreshSticky).observe(buy);
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky);
      refreshSticky();
    }
    scope.querySelectorAll('[data-dm-select]').forEach(card => card.addEventListener('click', () => {
      if (checkoutPending) return;
      const base = variants.find(v => String(v.id) === card.dataset.dmSelect);
      if (base) chooseConfiguration(base.label, addon?.checked);
      offer?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      [...colorButtons].find(button => button.dataset.dmColor === base?.label)?.focus({ preventScroll: true });
    }));
    buys.forEach(button => button.addEventListener('click', async event => {
      event.preventDefault();
      if (button.getAttribute('aria-disabled') === 'true' || checkoutPending || !window.DM_MARKET?.verified || window.DM_MARKET.pending || window.DM_MARKET.switching) return;
      const variant = variants.find(item => String(item.id) === String(select?.value));
      if (!variant?.available || !ready) return;
      checkoutPending = true;
      if (window.DM_MARKET) window.DM_MARKET.checkoutPending = true;
      scope.querySelectorAll('[data-dm-market-open],[data-dm-change-country]').forEach(control => { control.disabled = true; });
      const checkoutCountry = window.DM_MARKET?.country || 'PT';
      const originalLabels = buys.map(b => b.textContent);
      buys.forEach(b => { b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); b.textContent = i18n.t('A abrir o pagamento…'); });
      colorButtons.forEach(b => { b.disabled = true; });
      scope.querySelectorAll('[data-dm-select]').forEach(card => { card.disabled = true; });
      if (addon) addon.disabled = true;
      if (availability) availability.textContent = '';
      try {
        // A separate Storefront cart leaves the customer's existing Online Store cart intact.
          const response = await fetch('/api/2026-10/graphql.json', {
            signal: AbortSignal.timeout(20000),
          method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: 'mutation SingleProductCheckout($input: CartInput!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity cost { subtotalAmount { amount currencyCode } } lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } } } pageInfo { hasNextPage } } } userErrors { message } warnings { code message } } }',
            variables: { country: checkoutCountry, language: activeMarket().apiLanguage, input: { lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variant.id}`, quantity: 1 }], buyerIdentity: { countryCode: checkoutCountry } } }
          })
        });
        const result = await response.json();
        const created = result.data?.cartCreate;
        const cart = created?.cart;
        const lines = cart?.lines?.nodes || [];
          if (!response.ok || result.errors?.length || created?.userErrors?.length || created?.warnings?.length || cart?.cost?.subtotalAmount?.currencyCode !== activeMarket().currency || Number(cart?.cost?.subtotalAmount?.amount) !== variant.price / 100 || cart?.lines?.pageInfo?.hasNextPage || cart?.totalQuantity !== 1 || lines.length !== 1 || lines[0].quantity !== 1 || lines[0].merchandise?.id !== `gid://shopify/ProductVariant/${variant.id}`) throw new Error('Checkout unavailable');
          if (window.DM_MARKET && (!window.DM_MARKET.verified || window.DM_MARKET.switching || window.DM_MARKET.country !== checkoutCountry)) throw new Error('Market changed');
          const checkoutUrl = new URL(cart.checkoutUrl);
        if (checkoutUrl.protocol !== 'https:' || checkoutUrl.hostname !== location.hostname) throw new Error('Unexpected checkout destination');
        checkoutUrl.searchParams.set('locale', activeMarket().language);
        location.assign(checkoutUrl.href);
      } catch (_) {
        if (availability) availability.textContent = i18n.t('Não foi possível abrir o pagamento. Tente novamente.');
        checkoutPending = false;
          if (window.DM_MARKET) window.DM_MARKET.checkoutPending = false;
          scope.querySelectorAll('[data-dm-market-open],[data-dm-change-country]').forEach(control => { control.disabled = false; });
        buys.forEach((b,index) => { b.removeAttribute('aria-busy'); b.textContent = originalLabels[index]; });
        colorButtons.forEach(b => { b.disabled = false; });
        scope.querySelectorAll('[data-dm-select]').forEach(card => { card.disabled = !card.dataset.dmSelect; });
        applyVariant(select?.value, false);
        if (availability) availability.textContent = i18n.t('Não foi possível abrir o pagamento. Tente novamente.');
      }
    }));
    window.addEventListener('dm:market-state', () => applyVariant(select?.value || variants[0]?.id, false));
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      checkoutPending = false;
      if (window.DM_MARKET) { window.DM_MARKET.checkoutPending = false; window.DM_MARKET.switching = false; }
      buys.forEach((button, index) => { button.removeAttribute('aria-busy'); button.textContent = buyLabels[index]; });
      colorButtons.forEach(button => { button.disabled = false; });
      scope.querySelectorAll('[data-dm-select]').forEach(card => { card.disabled = !card.dataset.dmSelect; });
      scope.querySelectorAll('[data-dm-market-open],[data-dm-change-country]').forEach(control => { control.disabled = false; });
      window.DM_MARKET?.verifyPrices?.();
      applyVariant(select?.value, false);
    });
    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    applyVariant(variants.some(v => String(v.id) === urlVariant) ? urlVariant : select?.value || variants[0]?.id, false);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
